module.exports = __webpack_public_path__ + "img/empty-bg.17ac6e65.png";